// extracted by mini-css-extract-plugin
export var animationContainer = "_iy-0";
export var asteriskIcon = "_iy-8";
export var conversationLeftSection = "_iy-4";
export var conversationListItem = "_iy-3";
export var conversationMiddleSection = "_iy-5";
export var conversationRightSection = "_iy-6";
export var detailsContent = "_iy-1";
export var listContainer = "_iy-7";
export var modalContent = "_iy-2";